import styled from 'styled-components';
import { layout, media } from 'src/components/base';
import {
  OutlinedButton,
  PrimaryButton,
  TonalButton,
} from '@prisjakt/ui/button/variants';
import { maybeBlue700 } from '@prisjakt/design-tokens/light-theme-colors';
import { Dropdown } from '@prisjakt/ui/dropdown';
import { zindex } from 'src/ui/zindex';

export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${layout.measurements.spacing050};

  ${media.mediumDown`
    margin: 0;
  `}
`;

export const Filter = styled.div`
  width: fit-content;
`;

export const StyledModalInner = styled.div`
  display: grid;
  gap: ${layout.measurements.spacing150};
`;

export const StyledIconImageText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: ${layout.measurements.spacing050};
`;

export const StyledFooterInner = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${layout.measurements.spacing075};
`;

const CLEAR_BTN_MIN_WIDTH = '120px';

export const StyledClearButton = styled(TonalButton)`
  min-width: ${CLEAR_BTN_MIN_WIDTH};
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  flex: 1;
`;

export const StyledRelationsDropDown = styled(Dropdown)`
  z-index: ${zindex.overlay};
  margin-bottom: ${layout.measurements.spacing050};

  ${media.smallDown`
    display: none;
  `}
`;

export const RelationItem = styled.div`
  padding: ${layout.measurements.spacing025} ${layout.measurements.spacing075};

  ${media.smallOnly`
    padding: ${layout.measurements.spacing050} ${layout.measurements.spacing075};
  `}

  a {
    color: ${maybeBlue700};
  }
`;

export const OutlinedModalButton = styled(OutlinedButton)`
  ${media.mediumUp`
    display: none;
  `}
`;

export const ModalFooterContent = styled.div`
  display: flex;
  justify-content: flex-end;
`;
